import { Helmet } from "react-helmet-async";
import GallerySection from "../components/GallerySection";

export default function GalleryPage() {
  return (
    <>
      <Helmet>
        <title>Gallery | Nexalus Infotech</title>
        <meta
          name="description"
          content="Project gallery and installations from Nexalus Infotech — ELV and ICT systems across industries."
        />
      </Helmet>
      <main className="pt-24">
        <GallerySection />
      </main>
    </>
  );
}
